import { BalloonEventsMapOptions } from '../types/EmbedOptions';

export const DEFAULT_OPTIONS: BalloonEventsMapOptions = {
  rootId: '',
  key: '', // api key of the partner
  theme: { primaryColor: '#BF2088', primaryLight: '#F4E3F7' },
  type: 'map',
  version: 'latest',
  routingType: 'hash', // Use hash routing by default for embedded contexts
  initialLocation: { lng: 16.374586035203677, lat: 48.22080005036789 }, // [lng, lat]
  initialZoom: 14, // mapbox zoom level (lower -> farther away)
  mapboxStyle: 'mapbox://styles/balloon-events/cmgqgp3rc000l01s858opdon2',
  language: 'de', // iso: en/de
  useDateSearch: true, // show calendar on top
  useCategorySearch: true, // show categories on top
  useTextSearch: true, // show text search on top
  loadFromQuery: true,
  showBookmarkButton: false,
  showBottomCards: true,
  creatorURL: undefined,
  mapScrollable: true,
  previewCards: false,
  selectRandomEvent: false,
  openDetailsOnWebPlatform: false,
  showZeppelins: true,
  cooperativeGestures: false,

  // showPolygon: ['linz', 'steyr', 'molln'],
};
